import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import usePrint from "@/shared/hooks/usePrint";
import { errorToast } from "@/shared/utils/helpers";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useUnsavedPrinterMutation = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();
  const print = usePrint();

  const mutation = useMutation({
    mutationFn: (body: any) => {
      return post2(
        `/internal/secure/pos/v2/printerSettings/test/receipts/${branchId}`,
        body
      );
    },
    onSuccess: (data) => {
      toast.success(t("success.success"));
      print(data);
    },
    onError() {
      errorToast();
    },
  });

  return mutation;
};

export default useUnsavedPrinterMutation;
